import { UserType } from "@/types/user";

/**
 * Maps backend UserRole enum (uppercase) to frontend UserType enum
 * Backend returns: "INDIVIDUAL", "DEALER", "BUSINESS", "ADMIN" (from UserRole enum)
 * Frontend expects: UserType.Individual, UserType.Dealer, UserType.Business, UserType.Admin
 * 
 * Note: Backend does NOT have a "user" type - only INDIVIDUAL, DEALER, BUSINESS, ADMIN
 */
export function mapApiUserTypeToUserType(apiType: string): UserType {
    switch (apiType.toUpperCase()) {
      case 'DEALER':
        return UserType.Dealer;
      case 'ADMIN':
        return UserType.Admin;
      case 'INDIVIDUAL':
      case 'CONSUMER': // Legacy support for 'consumer' (maps to INDIVIDUAL in backend)
        return UserType.Individual;
      case 'BUSINESS':
        return UserType.Business;
      // Backend does not have a "user" type, but handle it gracefully as Individual
      case 'USER':
        return UserType.Individual; // Fallback to Individual for unknown 'user' type
      default:
        // Default to Individual for unknown types (should not happen with valid backend responses)
        return UserType.Individual;
    }
  }